import { Link } from "react-router-dom";
import { HeartPulse, Phone, Mail, MapPin, Facebook, Twitter, Instagram, Youtube } from "lucide-react";
import { NAV_LINKS, PROGRAMS, ORG } from "../data/content";

export const Footer = () => (
  <footer className="bg-[#0D1E18] text-white/75" data-testid="main-footer">
    <div className="container-hecso py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-hecso-green text-white">
            <HeartPulse className="w-5 h-5" />
          </span>
          <div className="leading-tight">
            <p className="font-heading font-semibold text-white text-sm">{ORG.name}</p>
          </div>
        </div>
        <p className="text-sm leading-relaxed">
          A non-profit organization working since 2004 to improve healthcare, education and social welfare
          for communities across Assam, India.
        </p>
        <div className="flex gap-3 mt-5">
          {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
            <a
              key={i}
              href="#"
              aria-label="Social link"
              data-testid={`footer-social-${i}`}
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-hecso-green hover:text-white"
            >
              <Icon className="w-4 h-4" />
            </a>
          ))}
        </div>
      </div>

      <div>
        <h4 className="font-heading text-white font-semibold mb-4 text-sm tracking-wide uppercase">Quick Links</h4>
        <ul className="space-y-2.5 text-sm">
          {NAV_LINKS.slice(1, 8).map((l) => (
            <li key={l.path}>
              <Link to={l.path} className="transition-colors hover:text-hecso-orange" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-heading text-white font-semibold mb-4 text-sm tracking-wide uppercase">Our Programs</h4>
        <ul className="space-y-2.5 text-sm">
          {PROGRAMS.slice(0, 6).map((p) => (
            <li key={p.slug}>
              <Link to="/programs" className="transition-colors hover:text-hecso-orange">
                {p.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-heading text-white font-semibold mb-4 text-sm tracking-wide uppercase">Contact Us</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex gap-2.5"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-hecso-orange" /> {ORG.address}</li>
          <li className="flex gap-2.5"><Phone className="w-4 h-4 mt-0.5 shrink-0 text-hecso-orange" /> {ORG.phone}</li>
          <li className="flex gap-2.5"><Mail className="w-4 h-4 mt-0.5 shrink-0 text-hecso-orange" /> {ORG.email}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-hecso py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
        <p>© {new Date().getFullYear()} {ORG.name} ({ORG.short}). All rights reserved.</p>
        <p>Established 18 April 2004 · Assam, India</p>
      </div>
    </div>
  </footer>
);
